// Regioni aderenti a Move-In e relative province (codici come in installersData.areas)
const regions = [
  { key: 'lombardia', label: 'Lombardia', provinces: ['VA', 'CO', 'SO', 'MI', 'BG', 'BS', 'PV', 'CR', 'MN', 'LC', 'LO', 'MB'] },
  { key: 'piemonte', label: 'Piemonte', provinces: ['TO', 'VC', 'NO', 'CN', 'AT', 'AL', 'BI', 'VB'] },
  { key: 'veneto', label: 'Veneto', provinces: ['VR', 'VI', 'BL', 'TV', 'VE', 'PD', 'RO'] },
  { key: 'emilia-romagna', label: 'Emilia-Romagna', provinces: ['PC', 'PR', 'RE', 'MO', 'BO', 'FE', 'RA', 'FC', 'RN'] }
];

// Pill di riserva per installatori con province fuori dalle regioni mappate
const OTHER_REGION_KEY = 'altre';

const otherRegion = installers => {
  const mapped = regions.reduce((acc, region) => acc.concat(region.provinces), []);
  const leftover = [...new Set(installers.map(installer => installer.admdiv2))].filter(code => code && !mapped.includes(code));
  return leftover.length > 0 ? { key: OTHER_REGION_KEY, label: 'Altre regioni', provinces: leftover } : null;
};

export default regions;
export { otherRegion, OTHER_REGION_KEY };
